goog.provide('el8.uiwidget.ClientConstructedFeed');

goog.require('el8.uiwidget.Feed');
goog.require('el8.model.base');


//=================================================
// UI Feed object for a fixed, client-created index
//
// We use this for static lists that pretend to be
// Feeds for convenience / interface reasons.
//
// Letter attachment groups use this for growth charts.
//=================================================
el8.uiwidget.ClientConstructedFeed = function(spec) {

    spec = spec || {};

    this._fixedIndex = spec.fixedIndex;

    el8.uiwidget.Feed.prototype.constructor.call(this, spec);
};
el8.uiwidget.ClientConstructedFeed.inheritsFrom(el8.uiwidget.Feed);

el8.uiwidget.ClientConstructedFeed.prototype.fetchDataIndex = function(opts) {

    /**
     * We override fetchDataIndex here because there is no urlIndex for this
     * kind of Feed - just a fixed index
     */
    if (!this._fixedIndex) { return; }

    opts = opts || {};

    this.loadIndex(this._fixedIndex);
    if (opts.successCb) { opts.successCb(this._fixedIndex); }
};

